import { ColoursValue, FontColoursKey, FontNameKey, FontWeightKey, IFontMap, IFontSizeVariants } from '@belong/types';
import { COLOURS } from './colour';

/**
 * The key is the font size and the values are the other css properties that need to be set
 */
export const FONT_MAP: IFontMap = {
  '1.5rem': {
    letterSpacing: '0',
    lineHeight: '2.0rem'
  },
  '1.7rem': {
    letterSpacing: '0',
    lineHeight: '2.4rem'
  },
  '2.0rem': {
    letterSpacing: '0',
    lineHeight: '2.8rem'
  },
  '2.4rem': {
    letterSpacing: '0.2px',
    lineHeight: '3.2rem'
  },
  '2.8rem': {
    letterSpacing: '0.2px',
    lineHeight: '3.2rem'
  },
  '3.2rem': {
    letterSpacing: '0.2px',
    lineHeight: '3.6rem'
  },
  '4.0rem': {
    letterSpacing: '-0.5px',
    lineHeight: '4.8rem'
  },
  '4.4rem': {
    letterSpacing: '0.2px',
    lineHeight: '4.8rem'
  },
  '4.8rem': {
    letterSpacing: '-1px',
    lineHeight: '4.8rem'
  },
  '6.0rem': {
    letterSpacing: '-1px',
    lineHeight: '6.0rem'
  }
};

export const FONT_NAME: Record<FontNameKey, string> = {
  PROXIMA_NOVA: 'ProximaNova',
  ARIAL_FALLBACK: 'ArialFallback'
};

export const FONT_WEIGHT: Record<FontWeightKey, number> = {
  BOLD: 700,
  SEMI_BOLD: 600,
  REGULAR: 400
};

export const FONT_BODY: IFontSizeVariants['body'] = {
  xs: {
    small: '1.5rem',
    medium: '1.7rem',
    large: '1.7rem'
  },
  md: {
    small: '1.5rem',
    medium: '1.7rem',
    large: '2.0rem'
  }
};

export const FONT_HEADING: IFontSizeVariants['heading'] = {
  xs: {
    xsmall: '1.7rem',
    small: '2.0rem',
    medium: '2.4rem',
    large: '2.8rem',
    xlarge: '3.2rem',
    xxlarge: '4.4rem'
  },
  md: {
    xsmall: '2.0rem',
    small: '2.4rem',
    medium: '3.2rem',
    large: '4.0rem',
    xlarge: '4.8rem',
    xxlarge: '6.0rem'
  }
};

export const FONT_SIZE: IFontSizeVariants = {
  body: FONT_BODY,
  heading: FONT_HEADING
};

export const FONT_COLOURS: Record<FontColoursKey, ColoursValue> = {
  ACTIVE: COLOURS.BELONG_BLUE,
  BASE: COLOURS.GREY_600,
  BASE_DARK: COLOURS.GREY_700,
  DISABLED: COLOURS.GREY_400,
  ERROR: COLOURS.DARK_RED,
  ERROR_ON_DARK: COLOURS.ALT_RED,
  FINE_PRINT: COLOURS.GREY_500,
  LIGHT: COLOURS.WHITE,
  MESSAGE: COLOURS.DARK_BLUE,
  STRONG: COLOURS.BLACK,
  SUCCESS: COLOURS.DARK_GREEN,
  WARNING: COLOURS.DARK_ORANGE,
  EMPHASIZE: COLOURS.PURPLE,
  MOSAIC: COLOURS.MOSAIC,
  MOSAIC_DARK: COLOURS.DARK_PURPLE,
  AFFORDANCE: COLOURS.BELONG_BLUE_ALT
};
